import React from 'react';
import { I18n } from '@aws-amplify/core';
import { RadioChangeEvent, type RadioGroupProps } from 'antd';
import { useHandleReports, type CustomReportData } from '../../../../hooks/useHandleReports';
import * as S from './styles';

export interface RadioGroupCustomReportOption {
	value: string;
	label: string;
	total: number;
	disabled: boolean;
	icon: JSX.Element;
	acronym: string;
}

interface RadioGroupCustomReportProps extends RadioGroupProps {
	options: RadioGroupCustomReportOption[];
	customReports: CustomReportData[];
}

export function RadioGroupCustomReport({
	options = [],
	customReports = [],
	value,
	onChange,
	...props
}: Readonly<RadioGroupCustomReportProps>) {
	const { clearAllReports } = useHandleReports(customReports);

	async function handleOnClick(itemValue: string, isDisabled: boolean): Promise<void> {
		if (isDisabled) return;
		const newValue = value === itemValue ? undefined : itemValue;
		onChange?.({ target: { value: newValue } } as RadioChangeEvent);
		await clearAllReports(newValue);
	}

	return (
		<S.RadioGroupWrapper buttonStyle="solid" value={value} onChange={onChange} {...props}>
			{options.map((item) => (
				<S.RadioGroupButtonWrapper
					key={item.value}
					value={item.value}
					disabled={item.disabled}
					onClick={() => handleOnClick(item.value, item.disabled)}
				>
					<S.ReportContent>
						<S.LeftContent>
							{item?.icon && <S.IconWrapper>{item.icon}</S.IconWrapper>}
							<S.NameWrapper>{I18n.get(item?.label)}</S.NameWrapper>
						</S.LeftContent>
						<S.CustomReportsSpan>{item.disabled ? '-' : item.total}</S.CustomReportsSpan>
					</S.ReportContent>
				</S.RadioGroupButtonWrapper>
			))}
		</S.RadioGroupWrapper>
	);
}
